'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _require = require('./utils'),
    parseArgs = _require.parseArgs;

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;
  return /*#__PURE__*/function () {
    var _tree = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, path, options) {
      var _parseArgs, _parseArgs2;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              _parseArgs = parseArgs(cid, path, options);
              _parseArgs2 = _slicedToArray(_parseArgs, 3);
              cid = _parseArgs2[0];
              path = _parseArgs2[1];
              options = _parseArgs2[2];

              if (options.preload !== false) {
                preload(cid);
              }

              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(ipld.tree(cid, path, options)), _awaitAsyncGenerator), "t0", 7);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function tree(_x, _x2, _x3) {
      return _tree.apply(this, arguments);
    }

    return tree;
  }();
};